import Highway from '@dogstudio/highway';

import Modal from '../components/modal/modal';
import HeroSlider from '../components/hero-slider/hero-slider';
import Share from '../components/share/share';
import Video from '../components/video/video';

let modal = null;
let heroSlider = null;
let share = null;
let video = null;

class ModalRenderer extends Highway.Renderer {
  onEnter() {
    const views = document.querySelectorAll('[data-router-view="modal"]');
    const view = views[views.length - 1];

    if (view.querySelector('.js-modal')) {
      modal = new Modal(view);
      modal.init();
    }

    if (view.querySelector('.js-hero-slider')) {
      heroSlider = new HeroSlider(view);
      heroSlider.init();
    }

    if (view.querySelector('.js-share')) {
      share = new Share(view);
      share.init();
    }

    if (view.querySelector('.js-video')) {
      video = new Video(view);
      video.init();
    }
  }

  onLeave() {
    const view = document.querySelector('[data-router-view="modal"]');

    if (view.querySelector('.js-modal')) {
      modal.destroy();
      modal = null;
    }

    if (view.querySelector('.js-hero-slider')) {
      heroSlider.destroy();
      heroSlider = null;
    }

    if (view.querySelector('.js-share')) {
      share.destroy();
      share = null;
    }

    if (view.querySelector('.js-video')) {
      video.destroy();
      video = null;
    }
  }
}

export default ModalRenderer;
